import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
  padding: 0;
`;

export const ContainerValores = styled.div`
  margin: 0;
  padding: 0;

  .titulo {
    background: #e0dfdf;
  }

  .div-edicao {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: wrap;

    gap: 10px;

    .div-edicao-item {
      margin-left: 10px;
      margin-right: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }

  .div-modulos {
    table {
      width: 100%;
      border-collapse: collapse;
    }
    th,
    td {
      min-width: 100px;
      text-align: right;
    }

    thead {
      /* background: #f5f5f5; */
    }

    .col-string {
      text-align: left !important;
    }
  }
`;
